import { serviceRoles } from "config/access";
import { STUDENT } from "constants/routes";
import { checkAccess } from "helpers/auth";
import StudentPage from "./container/StudentPage";

export default function getSettingsRoute(userAuth) {
  const { account, calendy } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [calendy.name]: [calendy.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: STUDENT,
    withSidebar: true,
    withAppBar: true,
    component: StudentPage,
  };
}
